module.exports = __webpack_public_path__ + "static/media/card_brand_mastercard.16e2b31e.svg";